import { createReducer } from "@reduxjs/toolkit";
import { createLesson, resetCreateLesson } from "./create-lesson";
import type { CreationState } from "@redux/state/shared-types";

const initialState: CreationState = { justCreatedId: null, processing: "idle" };

export const createLessonReducer = createReducer<CreationState>(initialState, builder => {
  builder.addCase(createLesson.fulfilled, (state, { payload }) => {
    return {
      ...state,
      justCreatedId: payload,
      processing: "success",
    };
  });
  builder.addCase(createLesson.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(createLesson.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetCreateLesson, () => {
    return initialState;
  });
});
